import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import Topic from './topic';
import BoxTitle from './boxTitle/';
import FinanceVideo from './financeVideo';
import ThinkTank from './thinkTank/';
import Meeting from './meeting/';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.col_R}>
                <Topic />
                <Chip id="170139" type="struct" title="右侧板块1" groupName="右侧板块" content={content.plate0}>
                    <BoxTitle />
                </Chip>
                <Chip
                    id="55016"
                    type="recommend"
                    title="财经推荐"
                    groupName="右侧板块"
                    position="relative"
                    translate="handleFinanceVideoData"
                    content={content.financeVideo}>
                    <FinanceVideo ad={content.financeVideoAd} />
                </Chip>
                <NoSSR onSSR={<div className={styles.box_1} />}>
                    <Ad content={content.asideAd1} styleName={styles.box_1} />
                </NoSSR>
                <div className={styles.box_finance}>
                    <Chip id="170140" type="struct" title="右侧板块2" groupName="右侧板块" content={content.plate1}>
                        <BoxTitle />
                    </Chip>
                    <Chip
                        id="170144"
                        type="struct"
                        title="右侧模块2内容"
                        groupName="右侧板块"
                        content={content.plateContent1}>
                        <ThinkTank />
                    </Chip>
                </div>
                <NoSSR onSSR={<div className={styles.box_2} />}>
                    <Ad content={content.asideAd2} styleName={styles.box_2} />
                </NoSSR>
                <div className={styles.box}>
                    <Chip id="230131" type="struct" title="右侧板块3" groupName="右侧板块" content={content.plate2}>
                        <BoxTitle />
                    </Chip>
                    <Chip
                        id="170146"
                        type="struct"
                        title="右侧板块3内容"
                        groupName="右侧板块"
                        content={content.plateContent2}>
                        <ThinkTank />
                    </Chip>
                    <NoSSR onSSR={<div className={styles.box_3} />}>
                        <Ad content={content.asideAd3} styleName={styles.box_3} />
                    </NoSSR>
                    <div className={styles.meeting} />
                    <Chip id="170141" type="struct" title="右侧板块4" groupName="右侧板块" content={content.plate3}>
                        <BoxTitle />
                    </Chip>
                    <Chip
                        id="200109"
                        type="struct"
                        title="右侧板块4内容"
                        groupName="右侧板块"
                        content={content.plateContent3}>
                        <ThinkTank />
                    </Chip>
                    <NoSSR onSSR={<div className={styles.box_4} />}>
                        <Ad content={content.asideAd4} styleName={styles.box_4} />
                    </NoSSR>
                </div>
                <div className={styles.meeting} />
                <Chip id="170142" type="struct" title="右侧板块5" groupName="右侧板块" content={content.plate4}>
                    <BoxTitle />
                </Chip>
                <Chip
                    id="200110"
                    type="struct"
                    title="右侧板块5内容"
                    groupName="右侧板块"
                    content={content.plateContent4}>
                    <ThinkTank />
                </Chip>
                <NoSSR onSSR={<div className={styles.box_5} />}>
                    <Ad content={content.asideAd5} styleName={styles.box_5} />
                </NoSSR>
                <div className={styles.meeting} />
                <Chip id="170143" type="struct" title="右侧板块6" groupName="右侧板块" content={content.plate5}>
                    <BoxTitle />
                </Chip>
                <Chip
                    id="170148"
                    type="struct"
                    title="右侧板块6内容"
                    groupName="右侧板块"
                    content={content.plateContent5}>
                    <ThinkTank />
                </Chip>
                <NoSSR onSSR={<div className={styles.box_6} />}>
                    <Ad content={content.asideAd6} styleName={styles.box_6} />
                </NoSSR>
                <div className={styles.meeting} />
                <Chip id="230132" type="struct" title="右侧板块7" groupName="右侧板块" content={content.plate6}>
                    <BoxTitle />
                </Chip>
                <Chip
                    id="170147"
                    type="struct"
                    title="右侧板块7内容"
                    groupName="右侧板块"
                    content={content.plateContent6}>
                    <ThinkTank />
                </Chip>
                <NoSSR onSSR={<div className={styles.box_7} />}>
                    <Ad content={content.asideAd7} styleName={styles.box_7} />
                </NoSSR>
                <div className={styles.meeting}>
                    <Chip id="230133" type="struct" title="右侧板块8" groupName="右侧板块" content={content.plate7}>
                        <BoxTitle>
                            <NoSSR onSSR={<div className={styles.meetingAd} />}>
                                <Ad content={content.meetingAd} styleName={styles.meetingAd} />
                            </NoSSR>
                        </BoxTitle>
                    </Chip>
                    <Chip
                        id="165043"
                        type="recommend"
                        title="专题会议"
                        groupName="正文"
                        translate="handleMeetingData"
                        content={content.meeting}>
                        <Meeting ad={content.meetingListAd} />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default RightContent;
